import clsx from "clsx";

export const CheckboxField = (props) => {
  const { label, disabled, value, registration, onChange, error } = props;
  return (
    <div className="flex justify-start p-4 border border-gray-300 shadow-sm rounded-md">
      <div>
        <div className="form-check flex flex-row items-center space-x-2">
          <input
            className="form-check-input appearance-none h-4 w-4 border border-orange-300 rounded-sm bg-white checked:bg-orange-600 checked:border-orange-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            type="checkbox"
            disabled={disabled}
            value={value}
            {...registration}
            onChange={onChange}
            id="flexCheckDefault"
          />
          <label
            className="form-check-label inline-block text-gray-600 text-sm"
            htmlFor="flexCheckDefault"
          >
            {label}
          </label>
        </div>
        {error}
      </div>
    </div>
  );
};
